import React from 'react';
import { useTranslation } from 'react-i18next';

import { PapiAttachmentFile, PapiDeviation } from '@wix/da-papi-types';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { BiData, SubmitAddImageClickBiEvent } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';

import PreviewThumb, { Props as PreviewThumbProps } from '../PreviewThumb';
import { useAttachmentManager } from '../../../hooks/useAttachmentManager';

import s from './AttachmentAddButton.scss';

interface Props extends PreviewThumbProps {
  deviation?: PapiDeviation;
  onAttachmentAdded?: (attachment: PapiAttachmentFile, deviation: PapiDeviation) => void;
}

const AttachmentAddButton: React.FC<Props> = ({ deviation, onAttachmentAdded }) => {
  const { t } = useTranslation();
  const { input, showFilePicker } = useAttachmentManager({
    deviation,
    onSuccess: onAttachmentAdded,
  });
  return (
    <>
      <PreviewThumb selected={false} draggable={false}>
        <IconButton
          className={s['btn-add']}
          size="medium"
          icon={AddIcon}
          tooltipOffset={[0, 8]}
          tooltipText={t('deviationSubmit.form.imageReplace.add.tooltip.text')}
          aria-label={t('deviationSubmit.form.imageReplace.add.tooltip.text')}
          onClick={showFilePicker}
          biData={
            deviation &&
            BiData<SubmitAddImageClickBiEvent>({
              evid: 30,
              typeid: getDeviationResourceType(deviation),
              itemid: deviation.deviationId,
              sectionname: 'attachment_slider',
              rank: (deviation.extended?.additionalMedia || []).length,
            })
          }
        />
        {input}
      </PreviewThumb>
    </>
  );
};

AttachmentAddButton.displayName = 'AttachmentAddButton';

export default AttachmentAddButton;
